export enum EventStatusEnum {
  'alarm',
  'warning',
  //   допиши потом все статусы
}
